import { TabTypes } from "app/utils/const";

const defaultFilters = {
  // The comments show the params that the filters affect in the competitions fetch
  bookmarksOnly: false, // bookmarksOnly, orderBy
  orderBy: TabTypes.POPULAR, //orderBy
  asianPreGameEventsOnly: false, // live, nonlive
  line: "MAIN", //line
  selectedDate: "ALL", // before, after.   change ALL to ALLDATES
  singleSelectedCompetitionId: null, // navigationNodeIds, before, after
  selectedCompetitionIds: null, // navigationNodeIds
};

export const asianCompetitionListFiltersModel = {
  state: defaultFilters,
  reducers: {
    // Update one filter
    setFilter(state, payload: { [key: string]: string }) {
      return { ...state, ...payload };
    },
    // Update a list of filters
    setFilters(state, payload: { [key: string]: boolean | string | null }[]) {
      console.log("setFilters payload: ", payload);
      const newState = { ...state };
      // Update state for each key value pair in the payload
      payload.forEach(filter => {
        for (const [key, value] of Object.entries(filter)) {
          newState[key] = value;
        }
      });

      return newState;
    },
    resetCompetitionListFilters: (state: Record<string, any>): any => {
      return { ...state, ...defaultFilters };
    },
  },
  effects: {},
};

export default asianCompetitionListFiltersModel;
